import React from 'react'
import OverlayHero from '../components/OverlayHero/OverlayHero'
import ServicesTextContent from '../components/ServicesTextContent/ServicesTextContent'
import BulletPoints from '../components/BulletPoints/BulletPoints'
import { Helmet } from 'react-helmet'

function IndustriesExpertise() {
  return (
    <div> 
      <Helmet>
          <link rel="canonical" href="https://www.lotusaccounting.ca/industry-expertise" />
           <title>
          
        </title>
        <meta
          name='description'
          content=''>
        </meta>
        </Helmet>
      <OverlayHero
        heading='Industry Expertise'
        bgImg="/images/creative/IndustryExpertise-hero-bg.webp"
      />

       <ServicesTextContent
            // subHeading="Who We Are"
            heading={"Lorem ipsum dolor sit amet, "}
            content={"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."}
            img={'/images/creative/ie-text-1.jpg'}
            shiftRow={true}
            bgColor={"white"}
            btn={false}
        />

        <BulletPoints/>
    </div>
  )
}

export default IndustriesExpertise